import React from 'react';

export default function SqlEditor({ value, onChange, fileInputRef, onFileUpload, minRows = 14, placeholder }) {
  const [focused, setFocused] = React.useState(false);
  const lines = value ? value.split('\n').length : 0;
  const chars = value ? value.length : 0;

  return (
    <div
      className="rounded-xl overflow-hidden"
      style={{
        border: focused ? '1px solid rgba(59,130,246,0.45)' : '1px solid #1e2130',
        boxShadow: focused ? '0 0 0 3px rgba(59,130,246,0.08)' : 'none',
        transition: 'border-color 0.15s, box-shadow 0.15s',
      }}
    >
      {/* Toolbar */}
      <div
        className="flex items-center justify-between px-4 py-2.5"
        style={{ backgroundColor: '#0f1117', borderBottom: '1px solid #1e2130' }}
      >
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#374151' }} />
          <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#374151' }} />
          <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#374151' }} />
          <span className="text-xs font-mono ml-2" style={{ color: '#374151' }}>sql</span>
        </div>
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="inline-flex items-center gap-1.5 text-xs rounded-lg px-3 py-1.5 font-medium transition-all"
          style={{ color: '#818cf8', border: '1px solid rgba(99,102,241,0.2)', backgroundColor: 'rgba(99,102,241,0.08)' }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(99,102,241,0.15)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.35)'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'rgba(99,102,241,0.08)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.2)'; }}
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M12 12V4m0 0L8 8m4-4l4 4" />
          </svg>
          Upload .sql file
        </button>
        <input ref={fileInputRef} type="file" accept=".sql" className="hidden" onChange={onFileUpload} />
      </div>

      {/* Code area */}
      <textarea
        value={value}
        onChange={onChange}
        rows={minRows}
        placeholder={placeholder || 'SELECT col1, col2\nFROM table_name\nWHERE condition = value'}
        style={{
          width: '100%',
          backgroundColor: '#0a0b10',
          color: '#86efac',
          fontFamily: "'Courier New', Courier, monospace",
          fontSize: '13px',
          lineHeight: 1.75,
          padding: '16px 20px',
          resize: 'vertical',
          outline: 'none',
          border: 'none',
          display: 'block',
          minHeight: `${minRows * 1.75 * 13 + 32}px`,
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />

      {/* Status bar */}
      <div
        className="flex items-center justify-between px-4 py-2"
        style={{ backgroundColor: '#0f1117', borderTop: '1px solid #1e2130' }}
      >
        <span className="text-xs font-mono" style={{ color: '#374151' }}>SQL</span>
        <div className="flex items-center gap-4">
          <span className="text-xs font-mono" style={{ color: '#374151' }}>{lines} {lines === 1 ? 'line' : 'lines'}</span>
          <span className="text-xs font-mono" style={{ color: '#374151' }}>{chars} chars</span>
        </div>
      </div>
    </div>
  );
}
